<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'
import {useModalsStore} from '@/stores/modals'
import PagePath from '@/common/PagePath.vue'
import Button from '@/common/Button.vue'

const props = defineProps({
    viewId: String,
    filterKey: Number
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Pinia Stores
const modalsStore = useModalsStore()

const filter = computed(() => {
    return viewStore.filters?.[props.filterKey] || null
})

const pageId = computed(() => {
    if (!filter.value || filter.value.value === undefined || filter.value.value === '') return null

    // Only parse if we have a valid structural representation
    return parseInt(filter.value.value) || null
})

const openSiteTreeModal = () => {
    if (!filter.value) return

    modalsStore.show({
        componentName: 'SiteTreeModal',
        obj: {
            pageId: pageId.value || 0,
            onPageSelect: selectedPageId => {
                viewStore.setFilterProp({
                    key: props.filterKey,
                    name: 'value',
                    value: selectedPageId
                })
            }
        }
    })
}
</script>

<template>
    <span>
        <Button @click="openSiteTreeModal" class="btn-sm border me-2">Browse…</Button>
        <span v-if="pageId" class="well well-sm m-0 p-1 text-nowrap">
            <PagePath :page-id="pageId"/>
        </span>
    </span>
</template>